export var ACTIONS = {
    SELECT_PREV: 'SELECT_PREV',
    SELECT_NEXT: 'SELECT_NEXT',
    SELECT_CURRENT: 'SELECT_CURRENT',
    SET_CURRENT_INDEX: 'SET_CURRENT_INDEX',
    SET_QUERY: 'SET_QUERY',
    ITEMS_LIST_UPDATED: 'ITEMS_LIST_UPDATED',
};
//# sourceMappingURL=actions.js.map